import { render, staticRenderFns } from "./ManyResult.vue?vue&type=template&id=09cb36ce"
import script from "./ManyResult.vue?vue&type=script&lang=ts"
export * from "./ManyResult.vue?vue&type=script&lang=ts"
import style0 from "./ManyResult.vue?vue&type=style&index=0&id=09cb36ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports